import React from "react";

import { useMe } from "../../contexts/me-context";
import AmeyoCallReceiver from "../CallReceiver/AmeyoCallReceiver";
// import { useSip } from "../../contexts/sip-context/sip-context";
// import KommunoCallReceiver from "../CallReceiver/KommunoCallReceiver";
// import CallReceiver from "../CallReceiver";

function CallManager() {
  // const { sip } = useSip();

  const {me} = useMe();

  if(!me?.sipEnabled) {
    return null;
  }

  return <AmeyoCallReceiver user={me}></AmeyoCallReceiver>

  // if (!sip?.call) {
  //   return null;
  // }

  // return <CallReceiver call={sip?.call} />;
}

export default CallManager;
